// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(53,192,0,1)',
    },
    secondary: {
      main: '#7c9583',
    },
  },
});

export default theme;

